import styled from "styled-components";

import { Link } from 'react-router-dom'

export const HeaderContainer = styled.div`
  padding: 20px;
`;

export const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const NavbarLink = styled.button`
  cursor: pointer;
  margin: 0;
  color: black;
  background-color: transparent;
  border: none;
  font-family: kreuz;
  font-size: 45px;
  font-weight: 400;
  @media (max-width: 767px) {
    font-size: 20px;
    color: black; 
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  &:visited,
  &:active {
    color: inherit;
    outline: none;
  }
`;